<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.parts.certifies.configuration.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    
                    <!-- Form row -->
                    <div  class="row">
                        <div class="col-md-12">
                            <div v-if="isAdminMaster() && data._id" class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.parts.perfil.certifies.label.decription')}}
                                </p>
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.socialName')}}
                                            </label>
                                            <input disabled type="text" v-model="data.socialName" class="form-control" style="background-color:azure">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.orders.company.phone.title')}}
                                            </label>
                                            <input disabled type="text" v-model="data.primaryPhone" class="form-control" style="background-color:azure">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.orders.company.email.title')}}
                                            </label>
                                            <input disabled type="text" v-model="data.email" class="form-control" style="background-color:azure">
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.document')}}
                                            </label>
                                            <input disabled type="text"  v-mask="['###.###.###-##', '##.###.###/####-##']" :value="data.document"  class="form-control" style="background-color:azure">
                                        </div>
                                    </div>

                                    <div id="accordion">
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                                    {{$t('string.msg.parts.perfil.truck.certified.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card-body">
                                                    <div class="d-flex flex-wrap">
                                                        <div class="container-switch" v-bind:key="item.id" v-for="item in this.certifies">
                                                            <label class="switch">
                                                                <input 
                                                                    v-model="data.certifies" 
                                                                    type="checkbox"
                                                                    :id="item._id" 
                                                                    :value="item._id"
                                                                    :true-value="item._id"
                                                                    :false-value="null"
                                                                    >
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <span class="label-swith">{{camelize(item.name).split('ZZZ_').join('')}}</span>
                                                        </div>
                                                        
                                                        <div class="container-switch">
                                                            <label class="switch">
                                                            <input 
                                                                v-model="data.certifies" 
                                                                @click="selectAll()"
                                                                type="checkbox"
                                                                id="selectAllItems" 
                                                                >
                                                            <span class="slider round"></span>
                                                            </label>
                                                            <span class="label-swith">{{$t('string.msg.select.all')}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button  @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                        <button @click="save" class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                </form>
                            </div>


                            <div v-else-if="!isAdminMaster()" class="card-box">
                                <form>
                                    <div id="accordion">
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                                    {{$t('string.msg.parts.perfil.truck.certified.company.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card-body">
                                                    <div class="d-flex flex-wrap">
                                                        <div class="container-switch" v-bind:key="item.id" v-for="item in this.certifies">
                                                            <label class="switch">
                                                                <input 
                                                                    disabled
                                                                    v-model="data.certifies" 
                                                                    type="checkbox"
                                                                    :id="item._id" 
                                                                    :value="item._id"
                                                                    :true-value="item._id"
                                                                    :false-value="null"
                                                                    >
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <span class="label-swith">{{camelize(item.name).split('ZZZ_').join('')}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                    <List v-show="isAdminMaster()" v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtPerfil';

import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import List from './ListCompanies';

export default {
  name: 'Certifies',
  components: {
    Spinner,
    Toast,
    List
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        certifies: [],
        user: null,
        isAllSelected: false,
        data: {
            certifies: [],

        }
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
        Controller.init(this);
  }
}
</script>

<style>
</style>
